import React from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar, SidebarSection, SidebarItem, Tooltip } from "components";
import { TagIcon, ArchiveIcon } from "./icons";
import { CREATE_ENTRIES } from "./createEntries";

/** Library filters, in display order. `divider` marks Archive's separation. */
const LIBRARY = [
  { filter: "all", label: "All Games", countKey: "all", icon: "▢" },
  { filter: "drafts", label: "Drafts", countKey: "drafts", dot: "var(--color-orange, #ff9f1c)" },
  { filter: "ready", label: "Ready", countKey: "ready", dot: "var(--color-teal, #2ec4b6)" },
  { filter: "in-progress", label: "In progress", countKey: "inProgress", dot: "var(--color-gold-orange, #ffb454)" },
  { filter: "played", label: "Played", countKey: "played", dot: "#94a3b8" },
  { filter: "archived", label: "Archive", countKey: "archived", icon: <ArchiveIcon />, divider: true },
];

const PLACEHOLDER_TAGS = ["work", "class"];

const DashboardSidebar = ({ counts = {}, activeFilter = "all", onFilter }) => {
  const navigate = useNavigate();

  return (
    <Sidebar className="da-sidebar">
      <SidebarSection label="Library">
        {LIBRARY.map((item) => (
          <React.Fragment key={item.filter}>
            {item.divider && <div className="da-sidebar-divider" />}
            <SidebarItem
              label={item.label}
              icon={item.icon}
              dot={item.dot}
              count={counts[item.countKey] ?? 0}
              active={activeFilter === item.filter}
              onClick={() => onFilter && onFilter(item.filter)}
            />
          </React.Fragment>
        ))}
      </SidebarSection>

      <SidebarSection label="Tags" className="da-sidebar-placeholder">
        <Tooltip title="Tag your games to organize — coming soon" placement="right">
          <div className="da-tag-chips">
            {PLACEHOLDER_TAGS.map((t) => (
              <span key={t} className="da-tag-chip">
                <TagIcon size={11} /> {t}
              </span>
            ))}
          </div>
        </Tooltip>
      </SidebarSection>

      <SidebarSection label="Create">
        {CREATE_ENTRIES.map(({ key, label, Icon, route, soon }) =>
          soon ? (
            <Tooltip key={key} title={soon} placement="right">
              <span>
                <SidebarItem icon={<Icon size={13} />} label={label} disabled />
              </span>
            </Tooltip>
          ) : (
            <SidebarItem
              key={key}
              icon={<Icon size={13} />}
              label={label}
              onClick={() => navigate(route)}
            />
          )
        )}
      </SidebarSection>
    </Sidebar>
  );
};

export default DashboardSidebar;
